module.exports = __webpack_public_path__ + "img/puzzle_31.25c7b24c.png";